import React from "react";

export const AppDrawerContext = React.createContext<
  [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>([undefined, undefined]);

export function useDrawer() {
  return React.useContext(AppDrawerContext);
}
